import React, { Component } from 'react'
import { Modal, Input, Table, Popconfirm, Form, InputNumber, Button, Avatar, Select } from 'antd'
import AddExpressForm from './AddItem'
import { sagaModal } from 'redux-saga-modal'
import * as utils from 'utils/index'
const EditableContext = React.createContext()
let company = []
for (var key in utils.expressCompanyCode) {
  var value = utils.expressCompanyCode[key]
  company.push({ name: value, id: value })
}
class EditableCell extends React.Component {
  getInput = () => {
    if (this.props.inputType === 'number') {
      return <InputNumber min={0} />
    }
    return <Input />
  }

  renderCell = ({ getFieldDecorator }) => {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      children,
      ...restProps
    } = this.props

    return (
      <td {...restProps}>
        {!editing ? children : (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: [
                {
                  required: true,
                  message: `请输入 ${title}!`,
                },
              ],
              initialValue: record[dataIndex],
            })(this.getInput())}
          </Form.Item>
        )}
      </td>
    )
  }

  render() {
    return <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
  }
}

@Form.create()
class ExpressTable extends Component {
  state = { editingKey: '', data: [], user: null }

  columns = [
    {
      title: '运单号',
      dataIndex: 'expressNo',
      key: 'expressNo',
      editable: true,
    },
    {
      title: '快递公司',
      dataIndex: 'expressCompany',
      key: 'expressCompany',
      editable: false,
    },
    {
      title: '手机号',
      dataIndex: 'mobile',
      key: 'mobile',
      width: 140,
      editable: true,
    },
    {
      title: '描述',
      dataIndex: 'desc',
      key: 'desc',
      editable: true,
      width: 130,
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      editable: false,
      width: 130,
    },
    {
      title: '创建人',
      dataIndex: 'user',
      key: 'user',
      editable: false,
      render: (user) =>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Avatar shape="circle" src={user?.avatar} />
          <span style={{ paddingLeft: 5 }}>{user?.name}</span>
        </div>
    },
    {
      title: '操作',
      dataIndex: 'control',
      width: 130,
      render: (text, record) => {
        const { editingKey } = this.state
        const editable = this.isEditing(record)
        return editable ? (
          <center>
            <EditableContext.Consumer>
              {form => (
                <a
                  href="javascript:"
                  onClick={() => this.save(form, record.key)}
                  style={{ marginRight: 8 }}
                >
                  保存
                </a>
              )}
            </EditableContext.Consumer>
            <a onClick={() => this.cancel(record.key)}>取消</a>
          </center>
        ) : (
          <center>
            <a
              style={{ marginRight: 8 }}
              disabled={editingKey !== ''}
              onClick={() => this.edit(record.key)}>
              修改
            </a>
            <a onClick={() => this.delete(record.key)}>删除</a>
          </center>
        )
      },
    },
  ]

  isEditing = record => record.key === this.state.editingKey

  cancel = () => {
    this.setState({ editingKey: '' })
  }

  save(form, key) {

    form.validateFields((error, row) => {
      if (error) {
        return
      }
      const newData = [...this.state.data]
      const index = newData.findIndex(item => key === item.key)
      if (index > -1) {
        const item = newData[index]
        newData.splice(index, 1, {
          ...item,
          ...row,
        })
        this.setState({ data: newData, editingKey: '' })
      } else {
        newData.push(row)
        this.setState({ data: newData, editingKey: '' })
      }
    })
  }

  edit(key) {
    this.setState({ editingKey: key })
  }

  delete(key) {
    this.setState({
      data: this.state.data.filter(item => item.key !== key)
    })
  }

  handleAddExpress = value => {
    const entity = {
      // key: Math.random().toString(36),
      expressNo: value.expressNo,
      expressCompany: value.expressCompany,
      desc: value.desc,
      // user: this.props.user,
      mobile: value.mobile,
      order: this.props.order?.get('_id')
    }
    console.log(entity)
    this.props.submit({
      orderId: this.props.order?.get('_id'),
      dataList: [entity]
    })
    // this.setState({
    //   data: [...this.state.data, entity],
    //   editingKey: ''
    // })
  }

  getColumns = () => {
    return this.columns.map(col => {
      if (!col.editable) {
        return col
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType: col.dataIndex,
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
        }),
      }
    })
  }

  componentDidMount() {
    const { order } = this.props

    const express = order.get('express').toJS();
    this.setState({
      data: express,
    })
  }

  submitHanler = () => {

    const { order } = this.props
    this.props.submit({
      data: { data: this.state.data, order_id: order._id }
    })
  }

  render() {
    const { data } = this.state
    const columns = this.getColumns()
    return (
      <EditableContext.Provider value={this.props.form}>
        {/* <h4>新增快递<span style={{ fontSize: 10, color: 'red' }}>(顺丰速运/丰网速运需填写收件人或寄件人手机号或手机号后四位)</span></h4> */}
        <AddExpressForm onSubmit={this.handleAddExpress} />
        {/* <h4>快递明细<span style={{ fontSize: 10, color: 'red' }}>(*快递公司与快递状态不支持修改，如要修改请删除后重新添加)</span></h4> */}
        {/* <Table
          components={{
            body: { cell: EditableCell }
          }}
          bordered
          dataSource={data}
          locale={{ emptyText: '暂无快递明细' }}
          columns={columns}
          rowClassName="editable-row"
          size="middle"
          pagination={false}
        /> */}
        {/* <div style={{ textAlign: 'right', marginTop: 20 }}>
          <Popconfirm
            title="请勿频繁操作，确定要保存运单明细?"
            onConfirm={this.submitHanler}
            okText="确认"
            cancelText="放弃">
            <Button type="primary">保存</Button>
          </Popconfirm>
        </div> */}
      </EditableContext.Provider>
    )
  }
}

function addExpressDialog({
  modal: {
    name,
  },
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) {
  return (
    <Modal
      title={ownProps.title}
      destroyOnClose
      footer={null}
      width={500}
      // style={{ top: '30vh' }}
      visible={isOpen}
      onCancel={hide}

      mask={false}
      wrapClassName="order-detail-modal-wrap"
      maskStyle={{ position: 'absolute' }}
      getContainer={() => (ownProps?.ele || document.getElementById('order-detail-wrap')) || window}
    >
      <ExpressTable {...ownProps} submit={submit} />
    </Modal>
  )
}

export default sagaModal({
  name: 'ORDER_EXPRESS_DIALOG',
})(addExpressDialog)
